import { sort } from '../../utils/helpers';
import actionHelpers from '../../utils/action-helpers';
import axios from 'axios';
const path = process.env.VUE_APP_ROOT_API;

// TODO: move grouping actions to grouping module that returns whatever groupings are fetched from the url param

const state = {
  status: null,
  categories: [],
  description: '',
  nextUrl: null,
  errors: [],
  filters: [],
  displayStyle: 'grid',
  sort: {
    direction: 'asc',
    field: 'name'
  }
};

const actions = {
  RESET_ERRORS: actionHelpers.RESET_ERRORS,
  RESET_STATUS: actionHelpers.RESET_STATUS,
  CLEAR_ITEMS: ({ commit }) => {
    commit('CLEAR_ITEMS');
  },
  SORT: ({ commit }, { direction, field, category }) => {
    commit('SORT_CATEGORIES', { direction, field, category });
  },
  FETCH_ALL: async ({ commit, dispatch }, payload) => {
    commit('CLEAR_ITEMS');
    commit('UPDATE_STATUS', 'loading');

    try {
      const { data } = await axios.get(`${path}/api/${payload.url}`);

      commit('UPDATE_STATUS', 'success');
      commit('SET_CATEGORY', { data, slug: payload.slug });
      dispatch('SORT', {
        direction: state.sort.direction,
        field: state.sort.field,
        category: payload.slug
      });
    } catch (error) {
      commit('UPDATE_STATUS', 'error');
      dispatch(
        'notification/ERROR_NOTIFICATION',
        'could not fetch items. try again later.',
        { root: true }
      );
    }
  },
  FETCH_MORE: () => {}
};

const mutations = {
  UPDATE_STATUS: (state, status) => (state.status = status),
  RESET_ERRORS: state => (state.errors = []),
  SET_ERROR: (state, error) => {
    state.errors = state.errors.concat(error);
  },
  UPDATE_DISPLAY_STYLE(state, { display }) {
    state.displayStyle = display;
  },
  CLEAR_ITEMS(state) {
    state.categories = [];
  },
  SORT_CATEGORIES(state, { direction, field = 'name', category }) {
    state.sort = { direction, field };

    if (state.categories && state.categories.length) {
      const cat = state.categories.find(o => {
        return o.slug === category;
      });
  
      cat.items = sort([...cat.items], direction, field);
    }
  },
  SET_CATEGORY: (state, { data, slug }) => {
    const categories = data.categories;
    const category = data.heading;
    const item = {
      name: category.toLowerCase(),
      slug,
      items: categories,
      total: categories.length
    };

    state.categories = state.categories.concat([item]);
  }
};

export default {
  namespaced: true,
  state,
  getters: {
    getBySlug: state => category => {
      return state.categories.find(o => {
        return o.slug === category;
      });
    }
  },
  actions,
  mutations
};
